import { Injectable, Provider } from '@angular/core';
import { Endereco } from 'src/app/api';

@Injectable()
export class PedidoService {
  getPedido(): any {
    throw new Error('not implemented');
  }
  setPedido(pedido) {
    throw new Error('not implemented');
  }
  updateEndereco(id: number, endereco: Partial<Endereco>): Promise<any> {
    throw new Error('not implemented');
  }
}

export function PedidoServiceFactory(i: any) {
  return i.get('Pedido');
}

export const PedidoServiceProvider: Provider = {
  provide: PedidoService,
  useFactory: PedidoServiceFactory,
  deps: ['$injector'],
};
